<template>
  <div class="select" v-click-outside="closeHanler">
    <div class="select__prev" @click="openHanlder">
      <div class="select__title">
        <span>{{ title }}</span>
        <span v-if="clearble || !isAllSelected"
          >Выбрано: <span>{{ syncSelected.length }}</span>
        </span>
        <span v-else>Все</span>
      </div>
      <div class="select__icons">
        <CloseRoundIcon
          :onClose="resetFilter"
          v-if="clearble || !isAllSelected"
          class="close-icon"
        />
        <span v-if="clearble || !isAllSelected" class="devider"></span>
        <ArrowDownIcon :class="{ rotate: isOpen }" />
      </div>
    </div>
    <Transition name="fade">
      <div
        v-if="isOpen"
        :style="{
          width: maxWidth && !display.smAndDown ? `${maxWidth}px` : undefined
        }"
        class="select__content"
      >
        <div v-if="display.smAndDown" class="mobile-header">
          <span>{{ title }}</span>
          <div @click="closeHanler" class="mobile-header__icon">
            <CloseBoldIcon />
          </div>
        </div>
        <SmSearchInput
          v-if="searchable"
          :style="{
            margin: display.smAndDown ? '8px 0px 12px 0px' : '0px 0px 12px 0px'
          }"
          :placeholder="searchable.placeholder"
          v-model="searchModel"
        />
        <div class="select__content-title">
          <CustomCheckbox v-model="isSelected" id="Selected All"
            >Выбрать всё
          </CustomCheckbox>
        </div>
        <div class="select__content--mobile">
          <div class="select__content-main">
            <template v-if="customContent">
              <CustomCheckbox
                class="card-item"
                v-model="syncSelected"
                v-for="(item, i, arr) in filtredItems"
                :key="i"
                :id="i"
                :values="item"
              >
                <slot :item="item" :index="i" :array="arr"></slot>
              </CustomCheckbox>
            </template>

            <template v-else>
              <CustomCheckbox
                v-for="(item, i) in filtredItems"
                class="card-item"
                v-model="syncSelected"
                :key="i"
                :id="i"
                :values="item"
              >
                <span>{{ itemTitle ? item[itemTitle] : item }}</span>
              </CustomCheckbox>
            </template>
          </div>
        </div>
        <div class="select__buttom">
          <span>Выбрано: {{ syncSelected.length }}</span>
          <Button :disabled="!syncSelected.length" :onClick="applyHandler"
            >Применить</Button
          >
        </div>
      </div>
    </Transition>
  </div>
</template>
<script>
import ArrowDownIcon from '@/assets/icons/arrow-down'
import CloseRoundIcon from '@/assets/icons/close-round'
import Button from '@/components/button'
import SmSearchInput from '@/components/smSearchInput'
import CloseBoldIcon from '@/assets/icons/close-bold'
import CustomCheckbox from './components/customCheckbox'
import { computed, ref, toRefs } from '@vue/composition-api'
import { useDisplay } from '@/hooks'

export default {
  name: 'select-filter',
  components: {
    ArrowDownIcon,
    Button,
    CloseRoundIcon,
    CustomCheckbox,
    CloseBoldIcon,
    SmSearchInput
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    value: {
      type: Array
    },
    maxWidth: {
      type: Number,
      required: false
    },
    searchable: {
      type: Object,
      required: false
    },
    customContent: {
      type: Boolean,
      required: false
    },
    clearble: {
      type: Boolean,
      required: false
    },
    itemTitle: {
      type: String,
      required: false
    }
  },
  computed: {
    syncSelected: {
      get() {
        return this.value ?? []
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  },
  setup(props, ctx) {
    const { items, value } = toRefs(props)
    const display = useDisplay()

    const isOpen = ref(false)
    const searchModel = ref('')

    const filtredItems = computed(() => {
      if (props.searchable) {
        if (!searchModel.value) return items.value
        const lowerCaseQuery = searchModel.value.toLowerCase()

        return items.value.filter(({ name }) => {
          const words = name.toLowerCase().split(' ')

          return words.some((word) => {
            const lowerCaseWord = word.toLowerCase()
            return lowerCaseWord.includes(lowerCaseQuery)
          })
        })
      }
      return items.value
    })

    const isAllSelected = computed(
      () =>
        // value.value ? value.value.length === items.value.length : false
        value.value.length === items.value.length
    )

    const isSelected = computed({
      get() {
        return value.value.length === filtredItems.value.length
      },
      set(v) {
        if (v) {
          ctx.emit('input', filtredItems.value)
          return
        }

        ctx.emit('input', [])
      }
    })

    let stashSelected = []

    function applyHandler() {
      this.$emit('submit', value.value)
      isOpen.value = false
    }

    function openHanlder() {
      if (isOpen.value) {
        if (JSON.stringify(stashSelected) !== JSON.stringify(value.value)) {
          ctx.emit('input', stashSelected)
        }
      }

      stashSelected = value.value
      isOpen.value = !isOpen.value
    }

    function resetFilter() {
      ctx.emit('reset-filter')
      ctx.emit('input', items.value)
    }

    function closeHanler() {
      if (!isOpen.value) return
      if (JSON.stringify(stashSelected) !== JSON.stringify(value.value)) {
        ctx.emit('input', stashSelected)
      }

      isOpen.value = false
    }

    return {
      isOpen,
      closeHanler,
      isAllSelected,
      applyHandler,
      openHanlder,
      resetFilter,
      isSelected,
      filtredItems,
      display,
      searchModel
    }
  }
}
</script>
<style lang="scss" scoped>
@import 'style';
</style>
